export default "/eth-usd.feba18fcef8f4b5bbc5a949e37550cf0.svg";